module.exports = __webpack_public_path__ + "static/media/about.c1d4d094.png";